export default function AgendaItemDocumentController(
  $q,
  $rootScope,
  $scope,
  alerts,
  oversightDataService,
  oversightSharedModelService,
  confirmDialog,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Agenda Item Document Added';
  vm.isExpanded = false;
  vm.canDeleteItem = vm.canDelete;

  // Attach Event Handlers
  vm.handleUnattachAgendaItemDocument = _handleUnattachAgendaItemDocument;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  function _handleUnattachAgendaItemDocument($event) {
    ssDialogService.dialogs.oversight.deleteAgendaItemDocumentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Remove Agenda Item Document?',
        message: `Are you sure you want to remove document "${vm.agendaItemDocumentDetail.description}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.oversight.deleteAgendaItemDocumentConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return oversightDataService.detachAgendaItemDocument(vm.agendaItemDocumentDetail.agendaItemDocumentId)
      .then(() => {
        alerts.success('The document has been removed successfully.');
        $rootScope.$broadcast('refreshAgendaItemDocuments', { agendaItemId: vm.agendaItemId });
        $rootScope.$broadcast('refreshAgendaItem', { agendaItemId: vm.agendaItemId });
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('An error occurred while removing the document.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.oversight.deleteAgendaItemDocumentConfirmDialog);
  }
}

AgendaItemDocumentController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'oversightDataService',
  'oversightSharedModelService',
  'confirmDialog',
  'docDataService',
  'loaderService',
  'orgDataService',
  'ssDialogService'
];
